<template>
  <v-app>
    <v-content>
      <v-container grid-list-md>
        <front-header />
        <v-layout row
                  wrap
                  style="padding: 30px 0px 0px;">
          <v-flex md7
                  xs12>
            <div class="container-left"
                 style="height: 547px;">
              <H1 class="font-weight-bold"
                  style="text-align: center;padding: 10px 0;">全国职业技能入库查询系统</H1>
              <v-form ref="form"
                      v-model="valid">
                <v-container>
                  <v-layout row
                            wrap>
                    <v-flex md12
                            xs12
                            d-flex
                            style="padding: 10px 0;">
                      <v-chip color="primary"
                              outlined
                              label>
                        <v-icon left>find_in_page</v-icon>
                        证书查询
                      </v-chip>
                    </v-flex>

                    <v-flex md12
                            xs12
                            style="padding: 5px 0;">
                      <v-text-field clearable
                                    label="姓名:(*必填)"
                                    v-model="firstname"
                                    :rules="nameRules"
                                    :counter="10"></v-text-field>
                    </v-flex>

                    <v-flex md12
                            xs12
                            style="padding: 5px 0;">
                      <v-text-field clearable
                                    v-model="zjnum"
                                    :rules="zjRules"
                                    :counter="18"
                                    label="证件号码:"></v-text-field>
                    </v-flex>

                    <v-flex md12
                            xs12
                            style="padding: 5px 0;">
                      <v-text-field clearable
                                    v-model="zsbh"
                                    label="证书编号:"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row
                            wrap
                            style="padding: 15px 0;">
                    <v-btn @click="submit"
                           color="success"
                           style="padding:0 30px;margin-right: 2%;">
                      <v-icon center>search</v-icon>
                      &nbsp;查 询
                    </v-btn>
                    <v-btn @click="clear"
                           color="error"
                           style="padding:0 30px;">
                      <v-icon center>clear</v-icon>
                      &nbsp;重 置
                    </v-btn>
                    <v-alert :value="true"
                             type="warning"
                             icon="warning"
                             outlined
                             style="border: none!important;padding:20px 0;">
                      注意事项:证件号码、证书编号至少输入一条信息，方可查询。
                    </v-alert>
                  </v-layout>
                </v-container>
              </v-form>
            </div>
          </v-flex>
          <v-flex md5
                  xs12>
            <div class="container-right">
              <v-container>
                <v-layout row
                          wrap>
                  <v-alert :value="true"
                           type="info"
                           icon="find_in_page"
                           outlined>查询方式</v-alert>
                  <v-flex>
                    <v-card flat>
                      <v-card-text>
                        「任意输入两项组合内容即可查询」 1.姓名+证件号码； 2.姓名+证书编号； 3.姓名+证件号码+证书编号；
                        注：当三个搜索条件都输入时，需要三个搜索条件都正确，方可查询到结果。 「例如」 1.输入正确姓名：叶ＸＸ； 2.输入正确的证件号码：36230119920816XXXX；
                        3.选择【查询】。在新窗口中显示此考生
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout row
                          wrap>
                  <v-alert :value="true"
                           type="warning"
                           icon="notification_important"
                           outlined>注意事项</v-alert>
                  <v-flex>
                    <v-card flat>
                      <v-card-text>
                        ① 职业技能证书查询系统仅限于查询本系统证书；<br />
                        ② 全国机构数据上传和审核需要一定的时间周期，如急需核实证书真伪，可致电颁发证书的机构；
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout row
                          wrap>
                  <v-alert :value="true"
                           color="success"
                           icon="phone"
                           outlined>联系方式</v-alert>
                  <v-flex>
                    <v-card flat>
                      <v-card-text>监督电话: 010-56159596； 地址: 北京市大兴工业开发区金苑路甲15号格雷众创园A座706-707</v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <front-footer />
  </v-app>
</template>

<script>
import frontheader from './core/Header';
import frontfooter from './core/Footer';

export default {
  components: {
    // 'front-header': frontheader,
    'front-footer': frontfooter
  },
  data: () => ({
    valid: false,
    firstname: '',
    nameRules: [v => (v && v.length >= 2) || '姓名不少于2个字'],
    zjnum: '',
    zjRules: [v => (v && v.length == 18) || '证件号码为18位'],
    zsbh: '',
    icons: ['fab fa-facebook', 'fab fa-twitter', 'fab fa-google-plus', 'fab fa-linkedin', 'fab fa-instagram']
  }),
  methods: {
    submit () {
      this.$router.push({
        path: '/userprofile',
        query: {
          firstname: this.firstname,
          zjnum: this.zjnum,
          zsbh: this.zsbh
        }
      });
    },
    clear () {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.container-left,
.container-right {
  background: #fff;
  padding-top: 20px;
}
.exp {
  padding-top: 20px;
}
.headline {
  font-size: 20px !important;
  line-height: 28px !important;
}
.v-alert {
  margin: 4px 0;
  width: 100%;
  font-size: 1.1em;
}
.v-input__control .v-input__slot {
  color: #1867c0 !important;
  caret-color: #1867c0 !important;
}
</style>
